// src/component/WalletModal.js
import React, { useEffect } from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import config from "../../config/config";
import { getMigrationAmountData } from "../../redux/slicess/migrationAmountDataSlice";
import { useDispatch, useSelector } from "react-redux";

const MigrationModal = ({
    show,
    handleClose,
}) => {
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const balance = useSelector((state) => state.migrationAmountData.migrationData);

    const handleNavigate = (id) => {
        navigate(`${config.baseUrl}Migration`, {
            state: { id: id }
        });
    };
    useEffect(() => {
        if (!balance || Object.keys(balance).length === 0) {
            dispatch(getMigrationAmountData());
        }
    }, [dispatch, balance]);

    const handleBusinessWalletTransferAction = () => {
        navigate(`${config.baseUrl}businesswallettransfer`, {
            state: { id: 4 },
        });
    };

    return (
        <Modal
            show={show}
            className="wallet-modal"
            size="lg"
            onHide={handleClose}
            centered
        >
            <Modal.Body className="d-flex flex-column align-items-center">
                <div className="wallet-main">
                    <div className="wallet-header py-2 px-3">Select Migration Wallet</div>

                    <div className="px-3 py-3">
                        <div className="wallet-card gap-2 mt-2 align-items-center px-3 py-3 position-relative overflow-hidden d-block">
                            <div>
                                <div className="d-flex d-sm-flex justify-content-between align-items-center mb-2">
                                    <p
                                        className="text-white mb-1 wallet-modal-data1"
                                        style={{ fontWeight: 700 }}
                                    >
                                        <span className="me-1">
                                            <img
                                                src="assets/images/walletback1.svg"
                                                style={{
                                                    position: "absolute",
                                                    right: 0,
                                                    opacity: 0.5,
                                                    top: 0,
                                                    zIndex: 0,
                                                }}
                                                alt=""
                                            />
                                            <img
                                                src="assets/images/walletback2.svg"
                                                style={{
                                                    position: "absolute",
                                                    left: 0,
                                                    top: 0,
                                                    opacity: 0.5,
                                                    zIndex:0
                                                }}
                                                alt=""
                                            />
                                            <img
                                                src="assets/images/wallet02.png"
                                                alt=""
                                                style={{ width: 35, height: 35 }}
                                            />
                                        </span>
                                        StepMint Wallet
                                    </p>
                                    <p
                                        className="text-white mb-0 wallet-modal-data2 text-end"
                                        style={{ fontWeight: 700 }}
                                    >
                                        <img src="assets/images/" alt="" />
                                        {balance.step_balance}{" "}
                                        <span style={{ fontSize: 9 }}>MNT</span>
                                    </p>
                                </div>
                                <Row className="justify-content-between">
                                    <Col xl={4} lg={4} className="mb-2 mb-md-0">
                                        <button
                                            onClick={() => handleNavigate(3)}
                                            disabled={balance.step_balance == 0}
                                            className="text-white px-3 px-sm-5 btn btn-main2 maxamount2 rounded-2 mb-2 mb-md-0 w-100"
                                            style={{ fontSize: 12 }}
                                            type="button"
                                        >
                                            <img src="assets/images/icon/withdraw.png" style={{ width: 20, height: 20 }}
                                                className="me-2"
                                            /> Migrrate
                                        </button>
                                    </Col>

                                    <Col xl={4} lg={4} className="mb-2 mb-md-0"></Col>
                                </Row>
                                {/* </div> */}
                            </div>
                        </div>
                        <div className="wallet-card gap-2 mt-2 align-items-center px-3 py-3 position-relative overflow-hidden d-block">
                            <div>
                                <div className="d-flex d-sm-flex justify-content-between align-items-center mb-2">
                                    <p
                                        className="text-white mb-1 wallet-modal-data1"
                                        style={{ fontWeight: 700 }}
                                    >
                                        <span className="me-1">
                                            <img
                                                src="assets/images/walletback1.svg"
                                                style={{
                                                    position: "absolute",
                                                    right: 0,
                                                    opacity: 0.5,
                                                    top: 0,
                                                    zIndex: 0,
                                                }}
                                                alt=""
                                            />
                                            <img
                                                src="assets/images/walletback2.svg"
                                                style={{
                                                    position: "absolute",
                                                    left: 0,
                                                    top: 0,
                                                    opacity: 0.5,
                                                }}
                                                alt=""
                                            />
                                            <img
                                                src="assets/images/wallet02.png"
                                                alt=""
                                                style={{ width: 35, height: 35 }}
                                            />
                                        </span>
                                        Business Wallet
                                    </p>
                                    <p
                                        className="text-white mb-0 wallet-modal-data2 text-end"
                                        style={{ fontWeight: 700 }}
                                    >
                                        <img src="assets/images/" alt="" />
                                        {balance.referral_balance}{" "}
                                        <span style={{ fontSize: 9 }}>MNT</span>
                                    </p>
                                </div>
                                <Row className="justify-content-between">
                                    <Col xl={4} lg={4} className="mb-2 mb-md-0">
                                        <button
                                            onClick={() => handleNavigate(4)}
                                            disabled={balance.referral_balance == 0}

                                            className="text-white px-3 px-sm-5 btn btn-main2 maxamount2 rounded-2 mb-2 mb-md-0 w-100"
                                            style={{ fontSize: 12 }}
                                            type="button"
                                        >
                                            <img src="assets/images/icon/withdraw.png" style={{ width: 20, height: 20 }}
                                                className="me-2"
                                            /> Migrrate
                                        </button>
                                    </Col>

                                    {/* <Col xl={4} lg={4} style={{ zIndex: 1 }}>
                                        <button
                                            onClick={handleBusinessWalletTransferAction}
                                            className=" text-white px-3 wallet px-sm-5 btn btn-main2 maxamount2 rounded-2 w-100"
                                            style={{ fontSize: 12 }}
                                            type="button"
                                        >
                                            Transfer
                                        </button>
                                    </Col> */}
                                </Row>
                                {/* </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default MigrationModal;
